export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const MAX_REFRESH_COUNT = 10;
export const TIMEOUT = 300;
export const UNAUTHORIZED = 401;
export const INTERNAL_SERVER_ERROR = 500;
export const AUTHORIZATION_HEADER = 'grpc-metadata-authorization';
export const ARS_VERSION_HEADER = 'grpc-metadata-ars-version';
export const SUPPLIER_HEADER = 'grpc-metadata-supplier';
export const ARS_API_VERSION = '3';
export const AGENT_HEADER = 'grpc-metadata-agent';

export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const WEEKDAYS = [
  'sun',
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat'
] as const;
export type Weekday = (typeof WEEKDAYS)[number];
export const CALENDAR_ROW = 6;
export const CALENDAR_COL = 7;

export const JAPANESE_LOCALE = 'ja';
export const ENGLISH_LOCALE = 'en';
export const CHINESE_LOCALE = 'zh';
export const TRADITIONAL_CHINESE_LOCALE = 'zt';
export const KOREAN_LOCALE = 'ko';

export const LOCALE_OPTIONS = [
  {
    value: ENGLISH_LOCALE,
    label: 'English'
  },
  {
    value: JAPANESE_LOCALE,
    label: '日本語'
  },
  {
    value: CHINESE_LOCALE,
    label: '简体中文'
  },
  {
    value: TRADITIONAL_CHINESE_LOCALE,
    label: '繁體中文'
  },
  {
    value: KOREAN_LOCALE,
    label: '한국어'
  }
] as const;

export { HOLIDAYS } from './holidays';
